import { createFileRoute, useParams } from '@tanstack/react-router';
import { ContractBaselineScreen } from '@/components/contract/baseline-screen';

/**
 * /contract/baseline — the "anchor" sub-route for Contract Compliance; the
 * `/contract` deep-link redirects here and the sub-tab strip lights up the
 * "Baseline" tab. The screen itself lives in
 * `components/contract/baseline-screen.tsx` (C20-133 / T-0102 / E06-F01).
 */
export const Route = createFileRoute('/engagements/$engagementId/contract/baseline')({
  component: ContractBaselineTab,
});

function ContractBaselineTab() {
  const { engagementId } = useParams({ from: '/engagements/$engagementId/contract/baseline' });
  return <ContractBaselineScreen engagementId={engagementId} />;
}

export { ContractBaselineTab };
